var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLove = function SvgLove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 13",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.755 1.158C13.93.391 12.82 0 11.725 0a4.497 4.497 0 0 0-3.028 1.158l-.707.658-.706-.658C6.459.391 5.348 0 4.254 0 3.128 0 2 .407 1.159 1.237c-1.615 1.58-1.514 4.085.135 5.619L7.47 12.6c.286.267.74.267 1.01 0l6.242-5.807c1.7-1.55 1.7-4.085.034-5.635Z"
  })));
};
export default SvgLove;